// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-39r","icon":"styles_icon__UfZB9"};